import fetch from 'isomorphic-fetch';
import { API } from '../../config';

export const getAllThemes = async () => {
  try {
    const response = await fetch(`${API}/themes`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};
export const getAllCustomers = async () => {
  try {
    const response = await fetch(`${API}/customers`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};

export const getAllEmployees = async () => {
  try {
    const response = await fetch(`${API}/employees`, {
      method: 'GET',
    });
    return await response.json();
  } catch (error) {
    return console.error(error);
  }
};